import { sdk } from 'src/utilities/sdk';

export interface IPaymentClientTokenResponse {
  client_token: string;
  payment_id: string;
  tokenizer: string;
  gh_tokenizer_url: string;
}

export interface ITokenizerCreditCardResponse {
  nonce: string;
  client_token: string;
}

export interface IRegisterCreditCardToAccount {
  corpId: string;
  onSuccess?: () => void;
  onError?: () => void;
  onFinally?: () => void;
  cardId?: string;
  tokenizeCallback: (
    token: string,
    tokenizerUrl: string
  ) => Promise<ITokenizerCreditCardResponse>;
}

export async function registerCreditCardToAccount({
  corpId,
  onSuccess,
  onError,
  onFinally,
  cardId,
  tokenizeCallback,
}: IRegisterCreditCardToAccount): Promise<void> {
  try {
    const paymentApiClientTokenUrl = `/payments/corporate/${corpId}/client_token`;
    const paymentResponse: IPaymentClientTokenResponse = await sdk.http.post(
      paymentApiClientTokenUrl,
      {
        payment_type: 'CREDIT_CARD',
      }
    );

    const tokenizeResponse: ITokenizerCreditCardResponse =
      await tokenizeCallback(
        paymentResponse.client_token,
        paymentResponse.gh_tokenizer_url
      );

    if (cardId) {
      await sdk.http.delete(`/payments/corporate/${corpId}/payments/${cardId}`);
    }

    const paymentApiCreditCardUrl = `/payments/corporate/${corpId}/credit_card/${paymentResponse.payment_id}`;
    await sdk.http.post(paymentApiCreditCardUrl, {
      payment_nonce: tokenizeResponse.nonce,
    });

    onSuccess?.();
  } catch (error) {
    onError?.();
  } finally {
    onFinally?.();
  }
}
